
export enum OriginLevel {
  Country = 1,
  State = 2,
  City = 3
}
